export class SignUpRequest {
  constructor(
    public userName: string,
    public email: string,
    public name: string,
    public password: string,
    public rememberPhrase: string
  ) {}
}
